import { State } from 'src/replicant/State';
import { match2MaxLevel } from '../match2.ruleset';
import { getLeagueLevel } from '../leagues/leagues.getters';
import { getMatch2MaxLevel } from '../match2.getters';
import { REGION_SIZE } from './regions.ruleset';

/**
 * Build the asset id for a region.
 * @param regionNumber
 */
export function buildRegionId(regionNumber: number): string {
  return `region_${regionNumber}`;
}

/**
 * Get region id for a given level, considering previous levels.
 * @param state
 * @param level - if not provided, current level will be used
 * @returns region id
 */
export function getRegionId(state: State, level?: number): string {
  if (!level) {
    level =
      state.match2.level > getMatch2MaxLevel(state)
        ? getLeagueLevel(state)
        : state.match2.level;
  }

  const region = getLevelRegion(level);
  return buildRegionId(region);
}

/**
 * Get region for a given level.
 */
export function getLevelRegion(levelNumber: number): number {
  return Math.floor((levelNumber - 1) / REGION_SIZE) + 1;
}

/**
 * Get the total regions available.
 */
export function getNumRegions(): number {
  return getLevelRegion(match2MaxLevel);
}

/**
 * Find out the region number for a given level, and return the first level of that region.
 * @param levelNumber
 * @returns
 */
export function getRegionFirstLevel(puzzleLevel: number): number {
  // Level 1 is region 1, so the first level is 1
  // Level 5 is region 1, so the first level is 1
  // Level 50 is region 1, so the first level is 1
  // Level 51 is region 2, so the first level is 51
  return (getLevelRegion(puzzleLevel) - 1) * REGION_SIZE + 1;
}

/**
 * Find out the region number for a given level, and return the last level of that region.
 * @param puzzleLevel
 * @returns
 */
export function getRegionLastLevel(puzzleLevel: number): number {
  // Level 1 is region 1, so the last level is 50
  // Level 5 is region 1, so the last level is 50
  // Level 50 is region 1, so the last level is 50
  // Level 51 is region 2, so the last level is 100
  const regionFirstLevel = getRegionFirstLevel(puzzleLevel);
  return regionFirstLevel + (REGION_SIZE - 1);
}
